module.exports = __webpack_public_path__ + "img/banner_recommend_3.fc34ed46.jpg";